export { Facilities, type Props } from './index.pc'
export { MobileFacilities } from './index.mobile'
